import React from 'react'
import bannerimg from "../../Assets/banner.png"
import "./Banner.css"
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

const Banner = () => {

    return (
        <>
            <div className="banner">
                <div className="banner-image">
                    <img src={bannerimg} alt="DLF The Crest" />
                </div>
                <div className="banner-stick">
                    <div className="banner-stick-box">
                        <span>New Launch</span>
                        <h2>DLF The Crest</h2>
                        <h5>At Sector 54, Gurugram</h5>
                        <h5>Stunning architecture influenced by the timeless elegance of European design.</h5>
                        <p>Premium 2, 3, 4, and 5 BHK Residence | Price Starts <span> ₹10.33 Cr*</span> </p>

                    </div>
                </div>
            </div>
        </>
    )
}

export default Banner
